import ExternalNavLink from './external-nav-link';

export default ExternalNavLink;
